import React, {Component} from 'react';
import StockStore from '../../stores/StockStore';
import {Modal,Button,ButtonToolbar,FormGroup,Form} from 'react-bootstrap'
import Select from 'react-select';
import FontAwesome from 'react-fontawesome'
import {connect} from 'react-redux'
class PullStock extends Component {

    constructor(props) {
      super(props)

      this.state = ({ defaultOption: "all", dataDd: [], data:[], cat_id:"" })
      //this.loadCategory()
    }

    componentWillReceiveProps(newProps){
      if(newProps.show && newProps.show !==this.props.show){
        this.loadCategory()
      }
    }

    loadCategory() {
      let that = this

      StockStore.loadCategory(this.props.stockType,function(result) {
        
        that.setState({dataDd:result.data})
      })
    }

    onCategoryChange(e) {
      this.setState({defaultOption: e.value, cat_id:e.value})
      // let that = this

      // ReportStore.loadStockList(this.props.stockType, "", e.value, "", "", function(result) {
      //   that.setState({data:result.data})
      // })
    }

    onSelectCategoryClick(e) {
      this.onHideClick(e)
      this.props.onDataChange(this.state.cat_id)
    }

    onHideClick(e) {
      this.props.onHide(false)
    }

    render(){
      let {messages} = this.props
      const options = [{"value":"all", "label":messages['All']}]
      {this.state.dataDd.map((item, index) =>
        options.push({
          value: item.cat_id,
          label: item.name
        })
      )}

      return (
        <Modal bsSize="small" show={this.props.show} onHide={this.onHideClick.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>
              {messages['Pull Data']}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <FormGroup>
                <Select
                  clearable={false}
                  name="form-field-name"
                  value={this.state.defaultOption}
                  options={options}
                  onChange={this.onCategoryChange.bind(this)}
                />
              </FormGroup>
            </Form>  
          </Modal.Body>
          <Modal.Footer>
            <ButtonToolbar className='pull-right'>
              <Button onClick={this.onSelectCategoryClick.bind(this)} className='btn btn-success' style={{minWidth:'80px'}}><FontAwesome name='download'/>&nbsp;{messages['Confirm']}</Button>
              <Button onClick={this.onHideClick.bind(this)}  style={{minWidth:'80px'}}><FontAwesome name='close'/>&nbsp;{messages['Cancel']}</Button>
            </ButtonToolbar>
          </Modal.Footer>
        </Modal>
      )
    }
}

PullStock.defaultProps = {
  show :false
}
export default connect(
  (state) => ({messages: state.message.component.element.PullStock}),null,null,{withRef:true},
)(PullStock);



// WEBPACK FOOTER //
// ./src/component/element/PullStock.js